import "./App.css";
import "./style/markdown.css";
import 'highlight.js/styles/github-dark.css';
import '@uiw/react-markdown-preview/markdown.css';
import '@uiw/react-md-editor/markdown-editor.css';
import { useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SnackbarProvider, SnackbarProviderProps } from "notistack";
import LoadingContextProvider from "./context/Loading/LoadingContextProvider";
import { LoginProvider } from "./context/Login/LoginContext";
import { CustomThemeProvider } from "./context/Theme/ThemeContext";
import AppRouter from "./router/AppRouter";
import { getEnvStr } from "./util/envFn";
import { setSnackbarRef } from "./util/snackbarUtil";
import './api';

function App() {
    return (
        <GoogleOAuthProvider clientId={getEnvStr("{GOOGLE_CLIENT_ID}")}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomThemeProvider>
                    <LoadingContextProvider>
                        <NotistackSnackbarProvider>
                            <LocalizationProvider >
                                <LoginProvider>
                                    <Stack
                                        direction="row"
                                        sx={{
                                            minHeight: "100dvh",
                                            minWidth: "100%",
                                            bgcolor: "background.default",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <AppRouter />
                                    </Stack>
                                </LoginProvider>
                            </LocalizationProvider>
                        </NotistackSnackbarProvider>
                    </LoadingContextProvider>
                </CustomThemeProvider>
            </LocalizationProvider>
        </GoogleOAuthProvider>
    );
}

const NotistackSnackbarProvider = (props: SnackbarProviderProps) => {
    const theme = useTheme();

    return (
        <SnackbarProvider ref={setSnackbarRef}
            maxSnack={3}
            autoHideDuration={3000}
            preventDuplicate
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            style={{
                fontSize: theme.typography?.caption?.fontSize,
                fontFamily: theme.typography?.caption?.fontFamily,
            }}
            // Components={{
            //     default: (props) => (
            //         <SnackbarContent
            //             {...props}
            //             style={{
            //                 fontSize: theme.typography?.caption?.fontSize,
            //                 fontFamily: theme.typography?.caption?.fontFamily,
            //             }}
            //         />
            //     )
            // }}
            {...props}
        />
    );
};

export default App;
